export interface GuCategory {
  key: string;
  label: string;
  desc: string;
  icon: string;
}

export const guCategories: GuCategory[] = [
  {
    key: "all",
    label: "全部吃瓜",
    desc: "不分类型，把最近最热的瓜一次看个够",
    icon: "ri-fire-line",
  },
  {
    key: "live",
    label: "直播翻车",
    desc: "直播间里的翻车瞬间，评论区风向反转最快的一类",
    icon: "ri-live-line",
  },
  {
    key: "love",
    label: "情感大瓜",
    desc: "官宣、分手、复盘，评论区考据党最活跃的战场",
    icon: "ri-heart-3-line",
  },
  {
    key: "business",
    label: "带货争议",
    desc: "代言、人设与信任，取关潮和解约风波的高发区",
    icon: "ri-shopping-bag-3-line",
  },
  {
    key: "comeback",
    label: "复出洗白",
    desc: "停更、回归与旧账，评论区永远记得当初发生了什么",
    icon: "ri-restart-line",
  },
  {
    key: "industry",
    label: "行业爆料",
    desc: "爆料帖与集体补充，评论区变成行业说明书",
    icon: "ri-file-shred-line",
  },
  {
    key: "feud",
    label: "互撕对决",
    desc: "连麦、对线、拉锯战，围观群众从站队到刷问号",
    icon: "ri-sword-line",
  },
];

export const getCategoryLabel = (key: string): string => {
  const found = guCategories.find((c) => c.key === key);
  return found ? found.label : "全部吃瓜";
};